<div class="action-holder align-self-center my-1">
  <ng-container *ngIf="tableRowData.manage.status && tableRowData.manage.reason === ConnectionStatus.Verified">
    <button
      type="button"
      [attr.data-test-id]="buildActionButtonTestId(CellActionTypes.SEND_MSG)"
      (click)="sendMessage()"
      [disabled]="deactivated"
      [ngbTooltip]="tooltipDescription(CellActionTypes.SEND_MSG) | translate"
      class="btn btn-link me-3"
    >
      <svg-icon src="assets/icons/icon-messages.svg" class="icon-messages"> </svg-icon>
    </button>
    <button
      type="button"
      [attr.data-test-id]="buildActionButtonTestId(CellActionTypes.REMOVE)"
      class="btn btn-link text-dark"
      [ngbTooltip]="tooltipDescription(CellActionTypes.REMOVE) | translate"
      (click)="remove()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </ng-container>

  <ng-container *ngIf="!tableRowData.manage.status || tableRowData.manage.reason === ConnectionStatus.None">
    <button
      appLongOperation
      [attr.data-test-id]="buildActionButtonTestId(CellActionTypes.ADD)"
      (click)="add()"
      [disabled]="deactivated"
      [ngbTooltip]="tooltipDescription(CellActionTypes.ADD) | translate"
      class="btn btn-link"
    >
      <svg-icon src="assets/icons/icon-add.svg" class="icon-add"> </svg-icon>
    </button>
  </ng-container>

  <ng-container *ngIf="tableRowData.manage.status && tableRowData.manage.reason === ConnectionStatus.Pending">
    <div
      [attr.data-test-id]="'relation-status-label-' + rowIndex + '-' + cellIndex"
      class="action-holder align-self-center my-1 ms-1 d-flex text-secondary header-font"
    >
      <span> {{'RELATION_REQUEST_PENDING_STATUS_HINT' | translate }} </span>
    </div>
  </ng-container>
</div>
